// extracted by mini-css-extract-plugin
export default {"divider":"detail_divider__eeDpG","opportunity":"detail_opportunity__qabtm","table":"detail_table__uGtNu","amount":"detail_amount__0OGfd","empty":"detail_empty__5bdmy"};